import { render } from "./Accomplish.vue?vue&type=template&id=8710a228"
import script from "./Accomplish.vue?vue&type=script&lang=js"
export * from "./Accomplish.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cageyoshida/sourcecodes/lotw-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__